(function($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfFieldMemberType', ['thfFieldHelper','$sce', function(thfFieldHelper, $sce) {
        var link = function(scope, el) {
            scope.isValid = thfFieldHelper.isValid;
            scope.labelIdentifier = thfFieldHelper.formLabelIdentifier();
            scope.tooltip = $sce.trustAsHtml((typeof scope.field.tooltip !== 'undefined') ? scope.field.tooltip : '');
            scope.selectItem = function( $event, value ) {
                $event.preventDefault();
                scope.model[scope.field.name] = value;

                var optionIndex = _.findKey(scope.field.options, { 'value': value });

                DSTAPI.track('event', {
                    category: 'Join Form - Your Cover',
                    action: 'Who is Cover For',
                    label: scope.field.options[optionIndex].label
                });
            };
        };

        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
                'formState': '=',
                'formField': '=',
                'formModel': '=',
                'field': '=',
                'validation': '=',
                'model': '=',
                'fieldActions': '=',
                'validationRules': '='
            },
            'link': link,
            'templateUrl': function() {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/fields/memberType.html');
            }
        };
    }]);
})(jQuery, angular, window);
